const dictionary = {
  pt: {
    // attributes: {
    //   email: 'Endereço de e-mail'
    // },
    messages: {
      after: 'Mensagem after',
      alpha: 'Mensagem alpha',
      alpha_dash: 'Mensagem alpha_dash',
      alpha_num: 'Mensagem alpha_num',
      alpha_spaces: 'Mensagem alpha_spaces',
      before: 'Mensagem before',
      between: 'Mensagem between',
      confirmed: 'Campos diferentes',
      credit_card: 'Mensagem credit_card',
      date_between: 'Data limite excedida',
      date_format: 'Data inválida',
      decimal: 'Utilize apenas números sem pontuação',
      digits: 'Mensagem digits',
      dimensions: 'Mensagem dimensions',
      email: 'E-mail inválido',
      ext: 'Mensagem ext',
      image: 'Mensagem image',
      included: 'Mensagem included',
      integer: 'Mensagem integer',
      ip: 'Mensagem ip',
      is: 'Valores diferentes',
      is_not: 'Mensagem is_not',
      length: 'Mensagem length',
      max: 'Mensagem max',
      max_date: 'A data deve ser atual ou passada',
      max_value: 'Valor máximo incorreto',
      mimes: 'Tipo de arquivo não suportado',
      min: 'Quantidade minima de caracteres incorreta.',
      min_value: 'Valor mínimo incorreto',
      excluded: 'Mensagem excluded',
      numeric: 'Apenas numerais',
      regex: 'Formato de campo incorreto e / ou incompleto',
      required: 'Campo obrigatório',
      size: 'O arquivo excede o tamanho limite',
      url: 'Mensagem url',
    },
  }
}

export default dictionary
